import Image from "./Image"
import Translation from "./Translation"

export default function ExperienceTime({ careers }) {
	function calculate() {
		let result = 0
		careers.filter((career) => career.type == "company").forEach((career) => {
			result += (career.end.getTime() - career.start.getTime())
		})
		return Math.ceil(result  / (1000 * 60 * 60 * 24) / 366)
	}

    return (
            <>
                <i>
                    <Image
                        src="experience_time"
                        alt="experience time"
                    />
                </i>
                <span>{ calculate() } { Translation("ans d'expériences") }</span>
            </>
        )
}